import toString from './to-string';
var lowerCase = function (str) {
  return toString(str).toLowerCase();
};
export default lowerCase;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.17@@antv/util/esm/lower-case.js
// module id = 80
// module chunks = 0